import {Alert, Button, Modal, Paper, Skeleton, styled, Typography} from "@mui/material";
import {TreeItem, treeItemClasses, TreeView} from "@mui/lab";
import {FolderOutlined, FolderRounded} from "@mui/icons-material";
import {getAllFolders} from "../../../lib/services/drive";
import {useEffect, useState} from "react";
import {LoadingButton} from "../../../theme/components/LoadingButton";
import Toasty from "../../../theme/components/Toasty";

const TransferModal = (props) =>  {

    const {open = false, onClose, onConfirm, pending, foldersId, ...restProps} = props;

    const [foldersData, setFoldersData] = useState({});
    const [allFolders, setAllFolders] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState();
    const [loading, setLoading] = useState(true);

    const getData = async () => {
        getAllFolders().then(payload => {
            let newData = {
                id: -1,
                name: "پوشه اصلی",
                type: "folder",
                subItems: [],
            };
            let allFolds = [];
            allFolds.push(newData);
            if (payload?.length) {
                payload.forEach(i => {
                    if (i.parentId !== undefined && i.parentId === 0) return // its Share Folder
                    allFolds.push(i);
                    i.subItems = [];
                    const subItems = payload.filter(f => f.parentId === i.id);
                    if (subItems.length) {
                        subItems.forEach(sub => {
                            if (foldersId?.includes(sub.id)) return; // Remove the current folder
                            sub.isChild = true;
                            i.subItems.push(sub);
                        })
                    }
                    if (!foldersId?.includes(i.id)) newData.subItems.push(i); // Remove the current folder
                    newData.subItems = newData.subItems.filter(s => s.isChild !== true);
                });
                newData.id = newData?.subItems[0]?.parentId;
            };
            setFoldersData(newData);
            setAllFolders(allFolds);
        }).then(() => setLoading(false))
            .catch((err) => {
                Toasty.error('خطایی غیر منتظره رخ داد');
                setLoading(false);
            });
    }

    const handleSelectFolder = (e, id) => {
        if (!allFolders?.length) return;
        const selected = allFolders.find(i => i.id === parseInt(id));
        if (selected) setSelectedFolder(selected);
    }

    useEffect(() => {
        setLoading(true);
    }, []);
    useEffect(() => {
        if (open) {
            getData();
        }
    }, [open, foldersId]);

    return (
        <StyledModal open={open} onClose={onClose} {...restProps}>
            <Paper elevation={25} sx={{ width: {xs: "90%", lg: "auto" }, minWidth: { lg: "25%" }, maxWidth: {xs: "90%", lg: "85%", xl: "75%", xxl: "65%"}, maxHeight: "90%", minHeight: "50%", p: 2.5, borderRadius: 2.5, overflowY: "auto" }}>
                {!loading
                    ?
                    foldersData?.subItems?.length
                        ?
                        <StyledTreeView
                            onNodeSelect={handleSelectFolder}
                            defaultExpandIcon={<FolderRounded />}
                            defaultCollapseIcon={<FolderOutlined />}
                            defaultEndIcon={<FolderRounded/>}>
                            <TreeItem nodeId={JSON.stringify(foldersData.id)} label={foldersData.name}>
                                <FoldersRecursive data={foldersData.subItems}/>
                            </TreeItem>
                        </StyledTreeView>
                        :
                        <Alert severity="warning">هیچ پوشه ای یافت نشد</Alert>
                    :
                    <Skeleton variant="rounded" width="100%" height="3.5rem"/>
                }
                <Typography mt={1.5}>پوشه انتخاب شده: {selectedFolder ? selectedFolder.name : "نامشخص"}</Typography>
                <LoadingButton
                    disabled={loading || !foldersData?.subItems?.length} loading={pending}
                    onClick={() => selectedFolder ? onConfirm(selectedFolder.id) : Toasty.error('لطفا پوشه را انتخاب کنید')}
                    variant="contained" fullWidth disableElevation
                    sx={{mt: 3, py: 1.4 }}>تایید</LoadingButton>
                <Button onClick={onClose} variant="outlined" fullWidth disableElevation sx={{mt: 1.5, py: 1.4 }}>لغو</Button>
            </Paper>
        </StyledModal>
    )
}
export default TransferModal;


const FoldersRecursive = ({data}) => {
    return (
            data.map((parent, index) => {
                return (
                    <TreeItem key={index} nodeId={JSON.stringify(parent.id)} label={parent.name}>
                        {/* Base Condition and Rendering recursive component from inside itself */}
                        {parent.subItems && parent.subItems.length ? <FoldersRecursive data={parent.subItems}/> : null}
                    </TreeItem>
                );
            })
    );
};

const StyledTreeView = styled(TreeView)(({theme}) => ({
    padding: 12,
    backgroundColor: theme.palette.grey.main,
    borderRadius: 4,
    [`& .${treeItemClasses.content}`]: {
        padding: 12,
        borderRadius: 4,
    }
}));
const StyledModal = styled(Modal)(({theme}) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));